import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Stream} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiStreamService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** streams ***/

  getStreams(): Promise<Stream[]> {
    const url = `${this.apiUrl}streams`;
    return firstValueFrom(this.http.get<Stream[]>(url))
  }
  getStreamsAula(aula: number): Promise<Stream[]> {
    const url = `${this.apiUrl}streams/${aula}`;
    return firstValueFrom(this.http.get<Stream[]>(url))
  }
  getStreamAula(aula: number): Promise<Stream> {
    const url = `${this.apiUrl}streams/start/${aula}`;
    return firstValueFrom(this.http.get<Stream>(url))
  }
  stopStream(uuid: string): Promise<void> {
    const url = `${this.apiUrl}streams/stop/${uuid}`;
    return firstValueFrom(this.http.get<void>(url))
  }
  saveStream(datos: Stream): Promise<number> {
    const url = `${this.apiUrl}streams`;
    return firstValueFrom(this.http.post<number>(url, datos))
  }
  updateStream(id: number, datos: Stream): Promise<void> {
    const url = `${this.apiUrl}streams/${id}`;
    return firstValueFrom(this.http.put<void>(url, {data: datos}))
  }
  deleteStream(id: number): Promise<void> {
    const url = `${this.apiUrl}streams/${id}`;
    return firstValueFrom(this.http.delete<void>(url))
  }

}
